import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { jsxs as e, jsx as n } from "react/jsx-runtime";
import { Fonts as t } from "@vds-core/typography";
import { calculateRem as r, withVDSManager as i, checkIfMobileDevice as o } from "@vds-core/utilities";
import { AccessibilityTokens as a } from "@vds-tokens/accessibility";
import { ColorTokens as l } from "@vds-tokens/color";
import { LayoutTokens as s } from "@vds-tokens/layout";
import { TypographyTokens as d } from "@vds-tokens/typography";
import c, { css as u } from "styled-components";
function v(e) {
  var n;
  return n = "small" === e ? 32 : 44, r(n);
}
function p(e, n) {
  var t, i;
  return "small" === e ? (t = "autoTight" === n ? s.space["3X"].value : s.space["4X"].value, i = s.space["2X"].value) : (t = "autoTight" === n ? s.space["5X"].value : s.space["6X"].value, i = s.space["3X"].value), "calc(".concat(r(i), " - 1px) ").concat(r(t));
}
var h = {
    use: "primary",
    disabled: !1,
    size: "large",
    display: "flex",
    width: "auto",
    surface: "light",
    onClick: void 0
  },
  f = c.span.withConfig({
    displayName: "HitArea",
    componentId: "VDS__sc-pwxi3s-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  width: 100%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  top: 50%;\n  content: '';\n  display: inline-block;\n  /*  pointer-events: none;  pointer-events is added here to ensure the correct item is returned by the onclick handler */\n  &:hover {\n    cursor: pointer;\n  }\n"])), r(44)),
  b = c.span.withConfig({
    displayName: "StyledChildWrapper",
    componentId: "VDS__sc-pwxi3s-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  max-width: 100%;\n  box-sizing: border-box;\n  display: inline-block;\n  vertical-align: middle;\n  align-items: center;\n  background: transparent;\n  justify-content: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  -webkit-tap-highlight-color: transparent;\n\n  &:focus {\n    outline: none;\n  }\n  ", ";\n  &:hover {\n    outline: none;\n    border: none;\n  }\n"])), function (_ref) {
    var e = _ref.size,
      n = _ref.width;
    return "\n          padding: ".concat(p(e, n), ";\n        ");
  }),
  g = function g(e) {
    return "string" == typeof e ? e : r(e);
  },
  m = u(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  pointer-events: auto;\n  padding: 0;\n  margin: 0;\n  border-width: ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  cursor: pointer;\n  display: ", ";\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  height: ", ";\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  touch-action: ", ";\n  pointer-events: ", ";\n  vertical-align: middle;\n  width: ", ";\n  min-width: ", ";\n  outline: none;\n  -webkit-tap-highlight-color: transparent;\n  ", ";\n  background-color: ", ";\n  border: ", " solid ", ";\n  color: ", ";\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), r(1), function (_ref2) {
    var e = _ref2.size;
    return v(e);
  }, function (_ref3) {
    var e = _ref3.display;
    return e;
  }, r(d.fontsize.body[16].value), r(d.lineheight.body[20].value), t.VerizonNHGeDS, d.fontweight.bold.value, "auto", function (_ref4) {
    var e = _ref4.disabled;
    return e ? "none" : "manipulation";
  }, function (_ref5) {
    var e = _ref5.disabled;
    return e && "none";
  }, function (_ref6) {
    var e = _ref6.width;
    return g(e);
  }, function (_ref7) {
    var e = _ref7.size;
    return function (e) {
      if ("large" === e) return r(76);
    }(e);
  }, function (_ref8) {
    var e = _ref8.size;
    return "small" === e ? "\n        font-size: ".concat(r(d.fontsize.body[12].value), ";\n        line-height: ").concat(r(d.lineheight.body[16].value), ";\n        font-weight: ").concat(d.fontweight.bold.value, ";\n        white-space: nowrap;\n        font-family: ").concat(t.VerizonNHGeTX, ";\n      ") : "\n        white-space: nowrap;\n        font-weight: ".concat(d.fontweight.bold.value, ";\n        letter-spacing: ").concat(r(d.letterspacing.wide.value), ";\n      ");
  }, function (_ref9) {
    var e = _ref9.$secondary;
    return e ? "transparent" : l.background.primary.inverse.light.value;
  }, r(1), l.elements.primary.onlight.value, function (_ref0) {
    var e = _ref0.$secondary;
    return e ? l.elements.primary.onlight.value : l.elements.primary.inverse.onlight.value;
  }, function (_ref1) {
    var e = _ref1.disabled,
      n = _ref1.surface,
      t = _ref1.$secondary,
      i = _ref1.size,
      o = _ref1.$isMobileDevice;
    return !e && "\n     &:focus:not(:hover) {\n      outline: none;\n      &::before {\n        border-color: ".concat("dark" === n ? a.color.focusring.ondark.value : a.color.focusring.onlight.value, ";\n        border: ").concat(r(a.focusring.borderwidth.value), " ").concat(a.focusring.borderstyle.value, " ").concat("dark" === n ? a.color.focusring.ondark.value : a.color.focusring.onlight.value, ";\n        border-radius: ").concat(v(i), ";\n        content: '';\n        height: calc(100% + ").concat(r(6), ");\n        left: 50%;\n        position: absolute;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        width: calc(100% + ").concat(r(6), ");     \n      }\n      &:focus:not(:focus-visible) {\n          &::before {\n            border: none; \n          }\n      }\n    }\n      &:hover:not(:active) {\n        outline: none;\n        ").concat(!o && "\n            box-shadow: 0 0 0 ".concat(r(1), " ").concat("dark" === n ? l.elements.primary.ondark.value : l.elements.primary.onlight.value, ";\n            transition: ease-out 0.1s;\n        "), ";\n      }\n      &:hover:not(:active) span {\n        border: none;\n      }\n      &:active {\n        color: ").concat("dark" === n ? t ? l.interactive.active.ondark.value : l.elements.primary.onlight.value : t ? l.interactive.active.onlight.value : l.elements.primary.ondark.value, ";\n        border-color: ").concat("dark" === n ? l.interactive.active.ondark.value : l.interactive.active.onlight.value, ";\n        ").concat(!o && "\n          box-shadow: 0 0 0 ".concat(r(1), " ").concat("dark" === n ? l.interactive.active.ondark.value : l.interactive.active.onlight.value, ";\n        "), ";\n        background-color: ").concat("dark" !== n || t ? "dark" === n || t ? "transparent" : l.interactive.active.onlight.value : l.interactive.active.ondark.value, ";\n      }\n      &:focus:active:not(:hover) {\n        box-shadow: none;\n      }\n    ");
  }, function (_ref10) {
    var e = _ref10.surface,
      n = _ref10.disabled,
      t = _ref10.$secondary;
    return "dark" === e && !n && "\n    background-color: ".concat(t ? "transparent" : l.background.primary.inverse.dark.value, ";\n    border: ").concat(r(1), " solid ").concat(l.elements.primary.ondark.value, ";\n    color: ").concat(t ? l.elements.primary.ondark.value : l.elements.primary.inverse.ondark.value, ";\n\n  ");
  }, function (_ref11) {
    var e = _ref11.disabled,
      n = _ref11.$secondary;
    return e && "\n    background-color: ".concat(n ? "transparent" : l.interactive.disabled.onlight.value, ";\n    border-color: ").concat(l.interactive.disabled.onlight.value, ";\n    color: ").concat(n ? l.interactive.disabled.onlight.value : l.elements.primary.ondark.value, ";\n    cursor: default;\n  ");
  }, function (_ref12) {
    var e = _ref12.disabled,
      n = _ref12.surface,
      t = _ref12.$secondary;
    return e && "dark" === n && "\n    background-color: ".concat(t ? "transparent" : l.interactive.disabled.ondark.value, ";\n    border-color: ").concat(l.interactive.disabled.ondark.value, ";\n    color: ").concat(t ? l.interactive.disabled.ondark.value : l.elements.primary.onlight.value, "\n  ");
  }),
  $ = c.button.withConfig({
    displayName: "StyledButton",
    componentId: "VDS__sc-pwxi3s-2"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n"])), m),
  y = c.a.withConfig({
    displayName: "StyledAnchor",
    componentId: "VDS__sc-pwxi3s-3"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  width: ", ";\n  justify-content: center;\n"])), m, function (_ref13) {
    var e = _ref13.width,
      n = _ref13.size;
    return "auto" !== e && "autoTight" !== e && "large" === n ? g(e) : "fit-content";
  }),
  k = function k(t) {
    var r = t.children,
      i = t.size,
      a = t.width,
      l = t.disabled,
      s = t.tabIndex,
      d = t.display,
      c = t.use,
      u = t.onClick,
      v = t.role,
      p = t.buttonRef,
      h = t["aria-label"] || t.ariaLabel ? t["aria-label"] || t.ariaLabel : "string" == typeof r ? r : "Button",
      g = o();
    var m;
    return m = "href" in t ? y : $, e(m, Object.assign({}, t, {
      ref: p,
      onClick: function onClick(e) {
        var n = e;
        if (n.target = e.currentTarget, u) return u(n);
      },
      size: i,
      width: a,
      "aria-label": h,
      role: v || (t.href ? "link" : "button"),
      "aria-disabled": t.disabled,
      tabIndex: l ? -1 : s || 0,
      display: d,
      disabled: l,
      $secondary: "secondary" === c,
      $isMobileDevice: g,
      children: [!l && n(f, {}), n(b, {
        tabIndex: -1,
        "aria-hidden": !!l || void 0,
        size: i,
        width: a,
        children: r
      })]
    }));
  };
k.defaultProps = h, k.displayName = "Button";
var w = i(k);
export { w as default };